import React from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import StarIcon from '@material-ui/icons/Star';
import { Link, useNavigate } from 'react-router-dom';
import { useTravelGuide } from '../../context/TravelGuideContext';

const formatPriceLabel = (priceLevel) => {
  if (!priceLevel || priceLevel === 'N/A') return 'Price not listed';
  if (priceLevel === '$$$$') return 'Price: Premium';
  if (priceLevel === '$$$') return 'Price: Upscale';
  if (priceLevel === '$$') return 'Price: Moderate';
  if (priceLevel === '$') return 'Price: Budget';
  return `Price: ${priceLevel}`;
};

const PlaceCardV2 = ({ place, compact = false, onAddToDay }) => {
  const navigate = useNavigate();
  const { state, dispatch } = useTravelGuide();
  const isSaved = state.savedPlaces.includes(place.id);
  const isCompared = state.comparePlaces.includes(place.id);

  return (
    <Card
      onClick={() => navigate(`/place/${place.id}`)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          navigate(`/place/${place.id}`);
        }
      }}
      role="button"
      tabIndex={0}
      elevation={compact ? 1 : 4}
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        cursor: 'pointer',
        transition: 'transform 180ms ease, box-shadow 180ms ease',
        border: '1px solid rgba(169, 144, 124, 0.26)',
        background: 'linear-gradient(180deg, #fffdf9 0%, #fff9f2 100%)',
      }}
    >
      <CardMedia
        image={place.photoUrl}
        title={place.name}
        style={{ height: compact ? 160 : 210, filter: 'saturate(0.95) contrast(1.03)' }}
      />
      <CardContent style={{ flexGrow: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6" component={Link} to={`/place/${place.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            {place.name}
          </Typography>
          <Box display="flex" alignItems="center" gridGap={4}>
            <StarIcon style={{ color: '#f59e0b' }} fontSize="small" />
            <Typography variant="body2">{place.rating.toFixed(1)}</Typography>
          </Box>
        </Box>
        <Typography variant="body2" color="textSecondary">
          {place.address || 'Address unavailable'}
        </Typography>
        <Box mt={1} display="flex" gridGap={6} flexWrap="wrap">
          <Chip size="small" label={`${place.reviews} reviews`} style={{ background: '#f4ece3' }} />
          <Chip size="small" label={formatPriceLabel(place.priceLevel)} style={{ background: '#f4ece3' }} />
        </Box>
      </CardContent>
      <CardActions style={{ padding: '0 12px 12px' }}>
        <Tooltip title={isSaved ? 'Remove from saved' : 'Save place'}>
          <IconButton
            color={isSaved ? 'secondary' : 'default'}
            onClick={(event) => {
              event.stopPropagation();
              dispatch({ type: 'TOGGLE_SAVE', payload: place });
            }}
            aria-label="Save place"
          >
            {isSaved ? <FavoriteIcon /> : <FavoriteBorderIcon />}
          </IconButton>
        </Tooltip>
        <Tooltip title={isCompared ? 'Remove from compare' : 'Add to compare'}>
          <IconButton
            color={isCompared ? 'primary' : 'default'}
            onClick={(event) => {
              event.stopPropagation();
              dispatch({ type: 'TOGGLE_COMPARE', payload: place.id });
            }}
            aria-label="Compare place"
          >
            <CompareArrowsIcon />
          </IconButton>
        </Tooltip>
        {onAddToDay && (
          <Button
            size="small"
            color="primary"
            onClick={(event) => {
              event.stopPropagation();
              onAddToDay(place.id);
            }}
          >
            Add to day
          </Button>
        )}
        <Button
          size="small"
          color="primary"
          component={Link}
          to={`/place/${place.id}`}
          onClick={(event) => event.stopPropagation()}
        >
          View Details
        </Button>
      </CardActions>
    </Card>
  );
};

export default PlaceCardV2;
